var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 2.95703C4.54834 1.85703 3.64834 0.957031 2.54834 0.957031C1.44834 0.957031 0.54834 1.85703 0.54834 2.95703C0.54834 4.05703 1.44834 4.95703 2.54834 4.95703C3.64834 4.95703 4.54834 4.05703 4.54834 2.95703Z",
    fill: "#1C3046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 16.957C4.54834 15.857 3.64834 14.957 2.54834 14.957C1.44834 14.957 0.54834 15.857 0.54834 16.957C0.54834 18.057 1.44834 18.957 2.54834 18.957C3.64834 18.957 4.54834 18.057 4.54834 16.957Z",
    fill: "#1C3046"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54834 9.95703C4.54834 8.85703 3.64834 7.95703 2.54834 7.95703C1.44834 7.95703 0.54834 8.85703 0.54834 9.95703C0.54834 11.057 1.44834 11.957 2.54834 11.957C3.64834 11.957 4.54834 11.057 4.54834 9.95703Z",
    fill: "#1C3046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVertical);
export default __webpack_public_path__ + "static/media/menu-vertical.acac548d39c92e7d78efb541919b8dca.svg";
export { ForwardRef as ReactComponent };